import React, { useState } from "react";
import toast from "react-hot-toast";
import { backendUrl } from "../Router/Constant";
import { useLanguage } from "../Router/LanguageContext";

export default function Contactus() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { dictionary } = useLanguage();

  const validate = () => {
    const newErrors = {};

    if (!form.firstName.trim()) {
      newErrors.firstName = dictionary?.firstNameRequired;
    }

    if (!form.lastName.trim()) {
      newErrors.lastName = dictionary?.lastNameRequired;
    }

    if (!form.email.trim()) {
      newErrors.email = dictionary?.emailRequired;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      newErrors.email = dictionary?.invalidEmail;
    }

    if (!form.phone.trim()) {
      newErrors.phone = dictionary?.phoneRequired;
    } else if (!/^[0-9+\-\s]+$/.test(form.phone)) {
      newErrors.phone = dictionary?.invalidPhone;
    }

    if (!form.message.trim()) {
      newErrors.message = dictionary?.messageRequired;
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();

    if (Object.keys(validationErrors).length === 0) {
      setErrors({});
      setLoading(true);

      try {
        const response = await fetch(backendUrl + "auth/quim-contact-support", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            firstName: form.firstName,
            lastName: form.lastName,
            email: form.email,
            phoneNumber: form.phone,
            message: form.message,
            website: "quimenergy",
          }),
        });

        const data = await response.json();

        if (response.ok) {
          setForm({
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            message: "",
          });

          toast.success(data?.data?.message || dictionary?.messageSent);
        } else {
          toast.error(data?.data?.message || dictionary?.somethingWrong);
        }
      } catch (error) {
        console.error("API Error:", error);
        toast.error(dictionary?.serverError);
      }

      setLoading(false);
    } else {
      setErrors(validationErrors);
    }
  };

   const handleChange = (e) => {
    const { name, value } = e.target;

    setForm({ ...form, [name]: value });

    // ✅ Remove error for that field when user types
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  
  return (
    <>
      <div className="section">
        <div className="container-fluid maxContainerSection container-contact-us-bottom">
          <div className="row contactSection">
            <div className="col-md-6 col-image-side img-cu-mobile d-block d-md-none">
              <img src="/assets/img/image-contact-us.jpg" alt="" />
            </div>

            {/* Left SIDE FORM */}
            <div className="col-md-6">
              <div className="contactFormCard">
                {/* <h2 className="m-0 mb-4 f-w-700 f-s-48">Contact me</h2> */}

                <form onSubmit={handleSubmit} noValidate>
                  <div className="row mb-4">
                    <div className="col-md-6 field-first-name">
                      <label className="f-w-500 f-s-14">
                        {dictionary?.firstName}
                      </label>
                      <input
                        type="text"
                        name="firstName"
                        className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
                        placeholder={dictionary?.enterFirstName}
                        value={form.firstName}
                        onChange={handleChange}
                      />
                      <div className="invalid-feedback">{errors.firstName}</div>
                    </div>

                    <div className="col-md-6">
                      <label className="f-w-500 f-s-14">
                        {dictionary?.lastName}
                      </label>
                      <input
                        type="text"
                        name="lastName"
                        className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
                        placeholder={dictionary?.enterLastName}
                        value={form.lastName}
                        onChange={handleChange}
                      />
                      <div className="invalid-feedback">{errors.lastName}</div>
                    </div>
                  </div>

                  <div className="mb-4">
                    <label className="f-w-500 f-s-14">
                      {dictionary?.email}
                    </label>
                    <input
                      type="email"
                      name="email"
                      className={`form-control ${errors.email ? "is-invalid" : ""}`}
                      placeholder={dictionary?.enterEmail}
                      value={form.email}
                      onChange={handleChange}
                    />
                    <div className="invalid-feedback">{errors.email}</div>
                  </div>

                  <div className="mb-4">
                    <label className="f-w-500 f-s-14">
                      {dictionary?.phoneNumber}
                    </label>
                    <input
                      type="text"
                      name="phone"
                      className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                      placeholder={dictionary?.enterPhone}
                      value={form.phone}
                      onChange={handleChange}
                    />
                    <div className="invalid-feedback">{errors.phone}</div>
                  </div>

                  <div className="mb-4">
                    <label className="f-w-500 f-s-14">
                      {dictionary?.message}
                    </label>
                    <textarea
                      name="message"
                      rows="4"
                      className={`form-control ${errors.message ? "is-invalid" : ""}`}
                      placeholder={dictionary?.writeMessage}
                      value={form.message}
                      onChange={handleChange}
                    />
                    <div className="invalid-feedback">{errors.message}</div>
                  </div>

                  <button
                    type="submit"
                    className="radius-btn"
                    disabled={loading}
                  >
                    {loading ? (
                      <div className="spinner-borderBtn">
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                        {dictionary?.sending}...
                      </div>
                    ) : (
                      <span className="btn-text">{dictionary?.submit}</span>
                    )}
                  </button>
                </form>
              </div>
            </div>

            <div className="col-md-6 col-image-side d-md-block d-none">
              <img src="/assets/img/image-contact-us.jpg" alt="" />
            </div>

            {/* LEFT SIDE */}
            <div className="col-md-12 contact-blocks d-flex flex-column flex-md-row justify-content-between">
              <div className="contactItem">
                <div className="iconBox">
                  <img src="/assets/img/icon-mail.svg" alt="" />
                </div>
                <div>
                  <h6 className="m-0 f-w-600 f-s-20">
                    {dictionary?.emailTitle}
                  </h6>
                  <p className="m-0 f-s-16">{dictionary?.emailDesc}</p>
                  <p className="m-0 f-s-16 contact-value f-w-600">
                    Geral@quimenergy.ao
                  </p>
                </div>
              </div>

              <div className="contactItem">
                <div className="iconBox">
                  <img src="/assets/img/icon-location.svg" alt="" />
                </div>
                <div>
                  <h6 className="m-0 f-w-600 f-s-20">
                    {dictionary?.officeTitle}
                  </h6>
                  <p className="m-0 f-s-16">{dictionary?.officeDesc}</p>
                  <p className="m-0 f-s-16 contact-value f-w-600">
                    Ingombota Palace Building, 3rd Floor, Luanda
                  </p>
                </div>
              </div>

              <div className="contactItem">
                <div className="iconBox">
                  <img src="/assets/img/icon-phone.svg" alt="" />
                </div>
                <div>
                  <h6 className="m-0 f-w-600 f-s-20">
                    {dictionary?.contactTitle}
                  </h6>
                  <p className="m-0 f-s-16">{dictionary?.contactDesc}</p>
                  <p className="m-0 f-s-16 contact-value f-w-600">
                    +244 973 088 141 , +244 947 885 958
                  </p>
                </div>
              </div>

              {/* <div className="contactIllustration">
                <img
                  src="/assets/img/img-contact-form.png"
                  alt="Illustration"
                  className="img-fluid"
                />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
